<div class="mainDiv">

    <div class="card">
        <div class="cardTitle">
            <h5>Moduli</h5>
        </div>
        <div class="cardBody">

            <div *ngFor="let module of createdModules">

                <!-- GRAFICA DELLA CARD -->
                <div class="max-w-sm rounded overflow-hidden cardDesign">

                    <div class="cardImage"><!--SEZIONE FOTO/TITOLO  -->
                        <app-drake-image-preview class="card-image" 
                            [fileId]="module.image.id" cssClasses="object-cover" 
                            alt="">
                        </app-drake-image-preview>
                        <div class="font-bold text-xl mb-2" style="padding:10px; margin:0 !important;">{{ module.title }}</div>
                    </div>
                    
                    <div class="cardText" ><!-- SEZIONE TESTO -->
                        <p class="text-gray-700 text-base">
                            {{ module.description }}
                        </p>
                    </div>
                    
                    <div class="px-6 pt-4 pb-2 cardButtonBox"><!-- SEZIONE ACQUISTA -->
                        <!-- PULSANTE ACQUISTA, visibile solo se cliccato, torna visibile se: viene scelto "indietro" -->
                        <div   class="buttonBuyVisible" [ngClass]="{ 'buttonBuyVisible': true,   'buttonBuyNoVisible': buyActivePresent(module._id) }">
                            <button class="buttonBuy" (click)="buyActive(module._id)">ACQUISTA</button>
                        </div>
                        
                        <div class="priceSectionNoVisibile" [ngClass]="{'priceSectionNoVisibile': true, 'priceSectionVisibile': buyActivePresent(module._id)}">

                            <mat-form-field appearance="fill">
                                <mat-select [(value)]="module.selectedPlans" name="price" id="price">
                                    <mat-option [value]="null" disabled>Seleziona un'opzione</mat-option>
                              
                                  <mat-option *ngFor="let option of module.price" [value]="{ id: option.id, price: option.price }">
                                    {{ option.title }} - {{ priceFormatter(option.price) }} €
                                  </mat-option>
                                </mat-select>
                              
                                <input type="hidden" name="importoNoShow" value="0">
                              </mat-form-field>


                            <div class="priceSectionButton">
                                <!-- PULSANTE AGGIUNGI AL CARRELLO -->
                                <button 
                                [disabled]="cartIsPresent(module._id) || !module.selectedPlans"
                                [ngClass]="{ 
                                  'buttonAdd': true, 
                                  'buttonNoHover': cartIsPresent(module._id) || !module.selectedPlans, 
                                  'buttonNoActive': cartIsPresent(module._id) || !module.selectedPlans 
                                }"  
                                type="button" 
                                class="buttonAdd" 
                                value="sendForm" 
                                (click)="addToCart(module._id, module.title, module.selectedPlans.id, module.selectedPlans.price)">
                              
                                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="size-6">
                                  <path stroke-linecap="round" stroke-linejoin="round" 
                                    d="M2.25 3h1.386c.51 0 .955.343 1.087.835l.383 1.437M7.5 14.25a3 3 0 0 0-3 3h15.75m-12.75-3h11.218
                                       c1.121-2.3 2.1-4.684 2.924-7.138a60.114 60.114 0 0 0-16.536-1.84M7.5 14.25L5.106 5.272M6 
                                       20.25a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0Zm12.75 0a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0Z" />
                                </svg>
                              
                              </button>
                                <!-- PULSANTE INDIETRO -->
                                <button 
                                    [disabled]="cartIsPresent(module._id) ? true : false"
                                    [ngClass]="{ 'buttonAdd': true, 'buttonNoHover': cartIsPresent(module._id), 'buttonNoActive': cartIsPresent(module._id)}"  
                                    type="button" 
                                    class="buttonAdd" 
                                    value="sendForm" 
                                    (click)="buyActive(module._id)">
        
                                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="size-6">
                                        <path stroke-linecap="round" stroke-linejoin="round" d="M6 18 18 6M6 6l12 12" />
                                      </svg>                              
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </div>
    </div>

    <div class="store">
        <!-- GRAFICA DEL CARRELLO -->
        <div class="storeTitle">
            <h5>Carrello</h5>
        </div>

        <div class="storeBody">

            <div class="header">
                <div style="width: 20%"></div>
                <div style="width: 60%"><b>MODULO SELEZIONATO:</b></div>
                <div style="width: 20%; text-align: right;"><b>PREZZO:</b></div>
            </div>

            <div class="body">
                <div *ngFor="let item of cart" class="item">
                    <div style="width: 20%">
                        <button type="button"
                        class="buttonDelete"
                        (click)="removeModule(item.id)" 
                        [title]="'grid.button.deleteRecord' | transloco" 
                        kendoButton [svgIcon]="deleteSVG">
                        </button>
                    </div>
                    <div style="width: 60%">{{item.title}}</div>
                    <div style="width: 20%; text-align: right;">€ {{ priceFormatter(item.price) }}</div> 
                </div>
            </div>

            <div class="footer">
                <h5>Prezzo totale (con IVA):</h5>
                <h5>€ {{ priceFormatter(storeAmount(cart)) }}</h5> 
            </div>
            <div class="buttonPaymentSection">
                <button 
                    type="button"
                    class="buttonPayment"
                    (click)="goToModulePayment()"
                    [disabled]="cartIsEmpty() ? true : false"
                    [ngClass]="{ 'buttonPayment': true, 'buttonNoHover': cartIsEmpty(), 'buttonNoActive': cartIsEmpty()}">

                    <svg xmlns="http://www.w3.org/2000/svg" fill="none"  viewBox="0 0 24 24"stroke-width="1.5" stroke="currentColor" class="size-6">
                        <path stroke-linecap="round" stroke-linejoin="round" d="M2.25 3h1.386c.51 0 .955.343 1.087.835l.383 1.437M7.5 14.25a3 3 0 0 0-3 3h15.75m-12.75-3h11.218c1.121-2.3 2.1-4.684 2.924-7.138a60.114 60.114 0 0 0-16.536-1.84M7.5 14.25 5.106 5.272M6 20.25a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0Zm12.75 0a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0Z" />
                    </svg>
                    PROCEDI AL PAGAMENTO
                </button>

            </div>
        </div>
    </div>

</div>